export enum MenuMode {
    DEFAULT,
    SETTINGS
}
